define('AddNoindexTag.EntryPoint', [
  'jquery',
  'underscore'
], function (
  jQuery,
  _
) {
  'use strict';
  return {
    mountToApp: function mountToApp(container) {
      var self = this;
      var environment = container.getComponent('Environment');
      var facets = environment && environment.getConfig('facets');
      var currentUrl = '';
      var isFacetUrl = false;
      jQuery(document).ready(function () {
        currentUrl = window.location.href || '';
        isFacetUrl = self.validateFacetList(currentUrl, facets);

        if (isFacetUrl) {
          self.addNoIndexMetaTag();
        } else {
          self.removeNoIndexMetaTag();
        }

        if (window.navigation && window.navigation.addEventListener) {
          window.navigation.addEventListener('navigate', function (event) {
            currentUrl = event && event.destination && event.destination.url || '';
            isFacetUrl = self.validateFacetList(currentUrl, facets);
            if (isFacetUrl) {
              self.addNoIndexMetaTag();
            } else {
              self.removeNoIndexMetaTag();
            }
          });
        } else {
          console.error('Navigation API is not supported in this browser.');
        }
      });
    },

    addNoIndexMetaTag: function addNoIndexMetaTag() {
      if (jQuery('meta[name="robots"]').length === 0) {
        jQuery('<meta>', {
          name: 'robots',
          content: 'noindex'
        }).appendTo('head');
      } else {
        jQuery('meta[name="robots"]').attr('content', 'noindex');
      }
    },

    removeNoIndexMetaTag: function removeNoIndexMetaTag() {
      jQuery('meta[name="robots"]').remove();
    },

    validateFacetList: function validateFacetList(currentUrl, facets) {
      if (currentUrl && facets.length > 0) {
        return _.some(facets, function (obj) {
          return currentUrl.indexOf(obj.id) !== -1;
        });
      }

      return false;
    }
  };
});
